export default __webpack_public_path__ + "static/media/Emotional09.b4815edd.png";